// extracted by mini-css-extract-plugin
export default {"scrollSection":"ScrollSection_scrollSection__hoaB5"};